import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const FilterBar = ({ filters, onFilterChange }) => {
  const typeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'job_application', label: 'Job Applications' },
    { value: 'message', label: 'Messages' },
    { value: 'payment', label: 'Payments' },
    { value: 'profile_activity', label: 'Profile Activity' },
    { value: 'system', label: 'System' }
  ];

  const priorityOptions = [
    { value: 'all', label: 'All Priorities' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' }
  ];

  const readStatusOptions = [
    { value: 'all', label: 'All' },
    { value: 'unread', label: 'Unread' },
    { value: 'read', label: 'Read' }
  ];

  return (
    <div className="bg-card border rounded-lg p-4">
      <div className="flex items-center gap-2 mb-3">
        <Icon name="Filter" size={18} className="text-muted-foreground" />
        <h3 className="text-sm font-semibold text-foreground">Filters</h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <Select
          options={typeOptions}
          value={filters?.type}
          onChange={(value) => onFilterChange?.({ type: value })}
          placeholder="Select type"
        />
        <Select
          options={priorityOptions}
          value={filters?.priority}
          onChange={(value) => onFilterChange?.({ priority: value })}
          placeholder="Select priority"
        />
        <Select
          options={readStatusOptions}
          value={filters?.isRead}
          onChange={(value) => onFilterChange?.({ isRead: value })}
          placeholder="Select status"
        />
      </div>
    </div>
  );
};

export default FilterBar;